/**
 * Viva PDP — synchro variantes (prix, média principal, URL) + miniatures galerie.
 */
(function () {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return [].slice.call((root || document).querySelectorAll(sel));
  }

  function parseJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents, data) {
    if (cents == null || isNaN(cents)) return '';
    var amount = cents / 100;
    var lang = document.documentElement.lang || 'fr-FR';
    var cur = (data && data.currency) || 'EUR';
    var mf = data && data.moneyFormat;
    if (mf && typeof mf === 'string' && mf.indexOf('{{') !== -1) {
      var raw2 = amount.toFixed(2);
      var raw2comma = raw2.replace('.', ',');
      var raw0 = String(Math.round(amount));
      var out = mf
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, raw2comma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, raw0)
        .replace(/\{\{\s*amount\s*\}\}/g, raw2);
      if (out.indexOf('{{') === -1) {
        return out.replace(/<[^>]*>/g, '');
      }
    }
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: cur
      }).format(amount);
    } catch (e2) {
      return amount.toFixed(2).replace('.', ',') + ' ' + ((data && data.currencySymbol) || '€');
    }
  }

  function syncOptionLabels(form) {
    qsa('.viva-size-opt, .size-opt, .variant-opt', form).forEach(function (lab) {
      var inp = lab.querySelector('input[type="radio"]');
      if (inp) lab.classList.toggle('active', inp.checked);
    });
  }

  /** Peluches 1:1 couleur/taille : chaque couleur = une seule taille (et inversement). */
  function isPairedColorSizeMatrix(data) {
    if (!data || !data.variants || data.variants.length < 2 || !data.optionNames) return false;
    var names = data.optionNames;
    var colorIdx = -1;
    var sizeIdx = -1;
    var i;
    for (i = 0; i < names.length; i++) {
      if (/^couleur$|^color$|^colour$|^motif$|^style$|^mod[eè]le$/i.test(names[i])) colorIdx = i;
      if (/^taille$|^taille\s+enfant$|^size$|^dimension$|^format$/i.test(names[i])) sizeIdx = i;
    }
    if (colorIdx < 0 || sizeIdx < 0 || colorIdx === sizeIdx) return false;

    var colorToSizes = {};
    var sizeToColors = {};
    data.variants.forEach(function (v) {
      var vo = [v.option1, v.option2, v.option3];
      var c = vo[colorIdx];
      var s = vo[sizeIdx];
      if (!c || !s) return;
      if (!colorToSizes[c]) colorToSizes[c] = {};
      colorToSizes[c][s] = true;
      if (!sizeToColors[s]) sizeToColors[s] = {};
      sizeToColors[s][c] = true;
    });

    var colorCount = Object.keys(colorToSizes).length;
    var sizeCount = Object.keys(sizeToColors).length;
    if (colorCount < 2 || sizeCount < 2) return false;
    if (data.variants.length !== colorCount || data.variants.length !== sizeCount) return false;

    var paired = true;
    Object.keys(colorToSizes).forEach(function (c) {
      if (Object.keys(colorToSizes[c]).length !== 1) paired = false;
    });
    Object.keys(sizeToColors).forEach(function (s) {
      if (Object.keys(sizeToColors[s]).length !== 1) paired = false;
    });
    return paired;
  }

  function pickBestVariantCandidate(candidates, data, opts, changedIdx) {
    if (!candidates.length) return null;

    function scoreVariant(v) {
      var vo = [v.option1, v.option2, v.option3];
      var score = v.available ? 1000 : 0;
      var i;
      var names = data.optionNames || [];
      for (i = 0; i < names.length && i < 3; i++) {
        if (i === changedIdx) continue;
        if (opts[i] != null && opts[i] !== '' && optEq(vo[i], opts[i])) score += 10;
      }
      return score;
    }

    candidates.sort(function (a, b) {
      return scoreVariant(b) - scoreVariant(a);
    });
    return candidates[0];
  }

  function variantForOptionValue(data, currentOpts, optionIdx, optionValue) {
    if (!data || !data.variants || !data.variants.length || optionIdx < 0) return null;
    var opts = currentOpts.slice();
    opts[optionIdx] = optionValue;
    var exact = findVariant(data, opts);
    if (exact) return exact;

    var names = data.optionNames || [];
    var candidates = data.variants.filter(function (v) {
      var vo = [v.option1, v.option2, v.option3];
      if (!optEq(vo[optionIdx], optionValue)) return false;
      if (isPairedColorSizeMatrix(data)) return true;
      var j;
      for (j = 0; j < names.length && j < 3; j++) {
        if (j === optionIdx) continue;
        if (currentOpts[j] != null && currentOpts[j] !== '' && !optEq(vo[j], currentOpts[j])) return false;
      }
      return true;
    });
    return pickBestVariantCandidate(candidates, data, currentOpts, optionIdx);
  }

  function syncOptionPrices(form, data) {
    if (!form || !data || !data.optionNames) return;
    var names = data.optionNames;
    var current = currentOptionSelections(form, data);

    qsa('[data-viva-option-price], .so-price', form).forEach(function (el) {
      var lab = el.closest('label.size-opt, label.variant-opt, label.viva-size-opt');
      if (!lab) return;
      var inp = lab.querySelector('input[type="radio"]');
      if (!inp) return;
      var optName = optionNameFromFieldName(inp.getAttribute('name') || '');
      if (optName == null) return;
      var idx = names.indexOf(optName);
      if (idx < 0) return;
      var v = variantForOptionValue(data, current, idx, inp.value);
      if (v) {
        el.textContent = formatMoney(v.price, data);
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });
  }

  function normOpt(val) {
    if (val == null || val === '') return '';
    try {
      return String(val).normalize('NFC').trim();
    } catch (eNorm) {
      return String(val).trim();
    }
  }

  function optEq(a, b) {
    return normOpt(a) === normOpt(b);
  }

  function isOptionField(el) {
    if (!el || !el.getAttribute) return false;
    var name = el.getAttribute('name') || '';
    if (name.indexOf('options[') !== 0) return false;
    return el.type === 'radio' || el.tagName === 'SELECT';
  }

  function findVariant(data, opts) {
    if (!data.variants || !data.variants.length) return null;
    var names = data.optionNames || [];
    var n = names.length;
    return data.variants.find(function (v) {
      if (n >= 1 && !optEq(v.option1, opts[0])) return false;
      if (n >= 2 && !optEq(v.option2, opts[1])) return false;
      if (n >= 3 && !optEq(v.option3, opts[2])) return false;
      return true;
    });
  }

  /** Combinaison partielle ou complète supportée par au moins une variante. */
  function optionValueAvailable(data, currentOpts, optionIdx, optionValue) {
    if (!data || !data.variants || !data.variants.length) return true;
    var trial = currentOpts.slice();
    trial[optionIdx] = optionValue;
    var names = data.optionNames || [];
    return data.variants.some(function (v) {
      var vo = [v.option1, v.option2, v.option3];
      for (var i = 0; i < names.length && i < 3; i++) {
        if (trial[i] == null || trial[i] === '') continue;
        if (!optEq(vo[i], trial[i])) return false;
      }
      return true;
    });
  }

  function optionFieldNodes(form, optionName) {
    var out = [];
    qsa('input[type="radio"][name="options[' + optionName + ']"]', form).forEach(function (n) {
      out.push(n);
    });
    qsa('select[name="options[' + optionName + ']"] option', form).forEach(function (n) {
      out.push(n);
    });
    return out;
  }

  /**
   * Indique les combinaisons impossibles (grisé) sans masquer les options —
   * évite l’effet « variante supprimée » sur les peluches 1:1 couleur/taille.
   * resolveVariant() réaligne couleur/taille au clic.
   */
  function syncOptionAvailability(form, data) {
    if (!form || !data || !data.optionNames) return false;
    var names = data.optionNames;
    var current = currentOptionSelections(form, data);

    for (var idx = 0; idx < names.length; idx++) {
      var optName = names[idx];
      qsa('input[type="radio"][name="options[' + optName + ']"]', form).forEach(function (inp) {
        if (inp.closest('.viva-opt-single-color-hidden')) return;
        var available = optionValueAvailable(data, current, idx, inp.value);
        var lab = inp.closest('label.size-opt, label.variant-opt, label.viva-size-opt');
        inp.disabled = false;
        if (lab) {
          lab.classList.toggle('is-unavailable', !available);
          lab.classList.toggle('is-disabled', !available);
          lab.style.display = '';
          lab.removeAttribute('aria-hidden');
        }
      });

      qsa('select[name="options[' + optName + ']"]', form).forEach(function (sel) {
        if (sel.closest('.viva-opt-single-color-hidden')) return;
        for (var o = 0; o < sel.options.length; o++) {
          var optEl = sel.options[o];
          if (!optEl.value) continue;
          var available = optionValueAvailable(data, current, idx, optEl.value);
          optEl.disabled = false;
          optEl.hidden = false;
          optEl.classList.toggle('is-unavailable', !available);
        }
      });
    }

    return false;
  }

  /**
   * Vêtements : ne pas basculer couleur/taille si la combinaison n’existe pas.
   * Peluches 1:1 : réaligner l’autre option (comportement historique).
   */
  function resolveVariant(data, opts, changedEl) {
    var exact = findVariant(data, opts);
    if (exact) return exact;
    if (!changedEl || !data.variants || !data.variants.length) return null;

    var changedName = optionNameFromFieldName(changedEl.getAttribute('name') || '');
    var names = data.optionNames || [];
    var changedIdx = changedName != null ? names.indexOf(changedName) : -1;
    if (changedIdx < 0) return null;

    var changedVal = changedEl.value;
    var paired = isPairedColorSizeMatrix(data);
    var candidates = data.variants.filter(function (v) {
      var vo = [v.option1, v.option2, v.option3];
      if (!optEq(vo[changedIdx], changedVal)) return false;
      if (paired) return true;
      var i;
      for (i = 0; i < names.length && i < 3; i++) {
        if (i === changedIdx) continue;
        if (opts[i] != null && opts[i] !== '' && !optEq(vo[i], opts[i])) return false;
      }
      return true;
    });
    return pickBestVariantCandidate(candidates, data, opts, changedIdx);
  }

  /** Le libellé serveur ne suit pas la variante : un bouton désactivé doit dire pourquoi. */
  function syncAtcLabel(addBtn, label) {
    var textNode = null;
    addBtn.childNodes.forEach(function (node) {
      if (!textNode && node.nodeType === 3 && node.textContent.trim()) textNode = node;
    });
    if (!textNode) return;
    if (!addBtn.hasAttribute('data-viva-atc-label')) {
      addBtn.setAttribute('data-viva-atc-label', textNode.textContent.trim());
    }
    textNode.textContent = label || addBtn.getAttribute('data-viva-atc-label');
    var icon = addBtn.querySelector('svg');
    if (icon) icon.style.display = label ? 'none' : '';
  }

  function syncAtcButtonState(form, data) {
    if (!form) return;
    var addBtn = form.querySelector('[name="add"]');
    if (!addBtn) return;
    if (!data) {
      addBtn.disabled = false;
      syncStickyAtcFromHero(form);
      return;
    }
    var opts = currentOptionSelections(form, data);
    var v = findVariant(data, opts);
    addBtn.disabled = !v || !v.available;
    syncAtcLabel(addBtn, !v ? 'Indisponible' : v.available ? '' : 'Épuisé');
    if (v && v.available) {
      addBtn.removeAttribute('title');
    } else if (!v) {
      addBtn.setAttribute('title', 'Cette combinaison est indisponible.');
    }
    syncStickyAtcFromHero(form);
  }

  var optionSyncLock = false;

  function onOptionChange(form, data, target) {
    if (optionSyncLock) return;

    syncOptionAvailability(form, data);

    var opts = currentOptionSelections(form, data);
    var v = findVariant(data, opts);
    if (!v && target) {
      v = resolveVariant(data, opts, target);
      if (v) {
        optionSyncLock = true;
        setFormOptionsFromVariant(form, v, data);
      }
    }

    if (optionSyncLock) {
      syncOptionAvailability(form, data);
      optionSyncLock = false;
    }

    var addBtn = form.querySelector('[name="add"]');
    if (v) {
      applyVariant(form, v, data);
      if (addBtn) addBtn.removeAttribute('title');
      if (window.VivaShopifyTracking && typeof VivaShopifyTracking.emitProductSelect === 'function') {
        VivaShopifyTracking.emitProductSelect(form, data, v);
      }
    } else {
      syncOptionLabels(form);
      syncOptionPrices(form, data);
      if (addBtn) {
        addBtn.disabled = true;
        syncAtcLabel(addBtn, 'Indisponible');
        addBtn.setAttribute('title', 'Cette combinaison est indisponible.');
      }
      syncStickyAtcFromHero(form);
    }
  }

  /**
   * Variante dont l’image mise en avant correspond au média cliqué.
   * En cas de doublons, privilégie la plus proche des options déjà choisies puis une variante disponible.
   */
  function pickVariantForMedia(data, mediaId, currentSelections) {
    if (!data || !data.variants || !data.variants.length || mediaId == null || mediaId === '') return null;
    var cand = [];
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (v.featured_media_id == null) continue;
      if (String(v.featured_media_id) !== String(mediaId)) continue;
      cand.push(v);
    }
    if (!cand.length) return null;
    currentSelections = currentSelections || [];
    function score(v) {
      var opts = [v.option1, v.option2, v.option3];
      var mc = 0;
      var j;
      for (j = 0; j < currentSelections.length && j < opts.length; j++) {
        if (currentSelections[j] != null && currentSelections[j] !== '') {
          if (optEq(currentSelections[j], opts[j])) mc += 10;
        }
      }
      return (v.available ? 1000 : 0) + mc;
    }
    cand.sort(function (a, b) {
      return score(b) - score(a);
    });
    return cand[0];
  }

  function setFormOptionsFromVariant(form, variant, data) {
    if (!form || !variant || !data || !data.optionNames) return;
    var names = data.optionNames;
    var vals = [variant.option1, variant.option2, variant.option3];
    var i;
    for (i = 0; i < names.length && i < 3; i++) {
      var nm = names[i];
      var val = vals[i];
      if (nm == null) continue;
      qsa('input[type="radio"][name^="options["]', form).forEach(function (inp) {
        var on = optionNameFromFieldName(inp.getAttribute('name') || '');
        if (!optEq(on, nm)) return;
        if (optEq(inp.value, val)) {
          if (inp.disabled) inp.disabled = false;
          inp.checked = true;
        } else {
          inp.checked = false;
        }
      });
      qsa('select[name^="options["]', form).forEach(function (sel) {
        var on = optionNameFromFieldName(sel.getAttribute('name') || '');
        if (!optEq(on, nm)) return;
        var o;
        var found = false;
        for (o = 0; o < sel.options.length; o++) {
          var optEl = sel.options[o];
          if (optEq(optEl.value, val)) {
            if (optEl.disabled) optEl.disabled = false;
            sel.selectedIndex = o;
            found = true;
            break;
          }
        }
        if (!found && val != null && val !== '') {
          sel.value = val;
        }
      });
    }
    syncOptionLabels(form);
  }

  function optionNameFromFieldName(fieldName) {
    if (!fieldName || fieldName.indexOf('options[') !== 0) return null;
    return fieldName.slice(8, fieldName.length - 1);
  }

  function currentOptionSelections(form, data) {
    if (!data || !data.optionNames) return [];
    var names = data.optionNames;
    var chosen = {};
    var radios = form.querySelectorAll('input[type="radio"][name^="options["]');
    for (var r = 0; r < radios.length; r++) {
      var inp = radios[r];
      if (!inp.checked) continue;
      var on = optionNameFromFieldName(inp.getAttribute('name') || '');
      if (on != null) chosen[on] = inp.value;
    }
    form.querySelectorAll('select[name^="options["]').forEach(function (sel) {
      var on = optionNameFromFieldName(sel.getAttribute('name') || '');
      if (on != null && chosen[on] === undefined) chosen[on] = sel.value;
    });
    var out = [];
    for (var i = 0; i < names.length; i++) {
      out[i] = chosen[names[i]];
    }
    var vidEl = form.querySelector('#viva-variant-id');
    if (vidEl && vidEl.value && data.variants) {
      var cv = data.variants.find(function (v) {
        return String(v.id) === String(vidEl.value);
      });
      if (cv) {
        var cvOpts = [cv.option1, cv.option2, cv.option3];
        for (var j = 0; j < names.length; j++) {
          if (out[j] == null || out[j] === '') out[j] = cvOpts[j];
        }
      }
    }
    return out;
  }

  function preloadMediaImage(media, quality) {
    if (!media) return;
    var src = quality === 'full' ? media.src || media.preview : media.preview || media.src;
    if (!src) return;
    var img = new Image();
    img.decoding = 'async';
    img.src = src;
  }

  /**
   * Précharge seulement les vues utiles à la navigation immédiate.
   * Charger toute la galerie en 800 + 1200px pénalise fortement le LCP mobile.
   */
  function prefetchNearbyProductMedia(data) {
    if (!data || !data.media || data.media.length < 2) return;
    var currentId = currentGalleryMediaId();
    var index = data.media.findIndex(function (m) {
      return String(m.id) === String(currentId);
    });
    if (index < 0) index = 0;
    preloadMediaImage(data.media[(index + 1) % data.media.length], 'preview');
    preloadMediaImage(data.media[(index - 1 + data.media.length) % data.media.length], 'preview');
  }

  function applyMainMedia(m, mediaIdStr) {
    var mainImg = document.querySelector('#viva-gal-main-img');
    if (!mainImg || !m) return;
    /* Déjà affichée (ex. variante initiale) : garder le srcset responsive et ne rien re-télécharger. */
    if (mainImg.getAttribute('data-media-id') === mediaIdStr) return;
    var low = m.preview || m.src;
    var high = m.src || m.preview;
    if (!low) return;

    var frame = mainImg.closest('.viva-pdp-media-frame');
    mainImg.setAttribute('data-media-id', mediaIdStr);
    mainImg.removeAttribute('srcset');
    mainImg.alt = m.alt || mainImg.alt || '';
    if (m.w) mainImg.width = m.w;
    if (m.h) mainImg.height = m.h;

    var clearSwapping = function () {
      if (frame) frame.classList.remove('viva-pdp-media-frame--swapping');
    };

    var stillCurrent = function () {
      return mainImg.getAttribute('data-media-id') === mediaIdStr;
    };

    if (frame) frame.classList.add('viva-pdp-media-frame--swapping');

    if (!high || low === high) {
      mainImg.src = low;
      var onDone = function () {
        clearSwapping();
        if (mainImg.decode && typeof mainImg.decode === 'function') {
          mainImg.decode().catch(function () {});
        }
      };
      if (mainImg.complete) {
        onDone();
      } else {
        mainImg.addEventListener('load', onDone, { once: true });
        mainImg.addEventListener('error', onDone, { once: true });
      }
      return;
    }

    mainImg.src = low;
    var revealedLow = function () {
      clearSwapping();
    };
    if (mainImg.complete) {
      revealedLow();
    } else {
      mainImg.addEventListener('load', revealedLow, { once: true });
      mainImg.addEventListener('error', revealedLow, { once: true });
    }

    var hi = new Image();
    hi.decoding = 'async';
    hi.onload = function () {
      if (!stillCurrent()) return;
      mainImg.src = high;
      mainImg.removeAttribute('srcset');
      if (mainImg.decode && typeof mainImg.decode === 'function') {
        mainImg.decode().catch(function () {});
      }
    };
    hi.onerror = function () {};
    hi.src = high;
  }

  function scrollThumbIntoStrip(thumb) {
    if (!thumb) return;
    var strip = thumb.closest('.gal-thumbs');
    if (!strip) return;
    var overflowX = window.getComputedStyle(strip).overflowX;
    var canScrollX =
      strip.scrollWidth > strip.clientWidth + 2 &&
      (overflowX === 'auto' ||
        overflowX === 'scroll' ||
        overflowX === 'overlay' ||
        strip.classList.contains('viva-uh-gal-thumbs--strip'));
    if (!canScrollX) return;
    var targetLeft = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
    try {
      strip.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    } catch (eScroll) {
      strip.scrollLeft = Math.max(0, targetLeft);
    }
  }

  function setActiveGalleryThumb(mediaId) {
    if (mediaId == null || mediaId === '') return;
    var idStr = String(mediaId);
    var activeThumb = null;
    qsa('.gal-thumb').forEach(function (t) {
      var isSel = String(t.getAttribute('data-media-id')) === idStr;
      t.classList.toggle('active', isSel);
      if (isSel) {
        activeThumb = t;
        t.setAttribute('aria-current', 'true');
      } else {
        t.removeAttribute('aria-current');
      }
    });
    if (activeThumb) scrollThumbIntoStrip(activeThumb);
  }

  function syncStickyAtcFromHero(form) {
    var addBtn = form.querySelector('[name="add"]');
    var stickyBtn = document.querySelector('[data-viva-sticky-atc-btn]');
    if (addBtn && stickyBtn) {
      stickyBtn.disabled = addBtn.disabled;
      if (addBtn.getAttribute('title')) {
        stickyBtn.setAttribute('title', addBtn.getAttribute('title'));
      } else {
        stickyBtn.removeAttribute('title');
      }
      var labelEl = stickyBtn.querySelector('.viva-pdp-sticky-atc__btn-label');
      if (labelEl) {
        var tmp = addBtn.cloneNode(true);
        qsa('svg', tmp).forEach(function (svg) {
          svg.parentNode.removeChild(svg);
        });
        labelEl.textContent = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
      }
      var heroSvg = addBtn.querySelector('svg');
      var stickySvg = stickyBtn.querySelector('svg');
      if (heroSvg) {
        var svgClone = heroSvg.cloneNode(true);
        svgClone.classList.add('viva-pdp-sticky-atc__btn-icon');
        if (stickySvg) {
          stickySvg.replaceWith(svgClone);
        } else {
          stickyBtn.appendChild(svgClone);
        }
      } else if (stickySvg) {
        stickySvg.remove();
      }
    }
  }

  function applyVariant(form, variant, data) {
    if (!variant) return;
    var hid = form.querySelector('input[name="id"]');
    if (hid) hid.value = String(variant.id);

    var nowEl = document.querySelector('[data-viva-price-current]');
    var oldEl = document.querySelector('[data-viva-price-compare]');
    var saveEl = document.querySelector('[data-viva-price-save]');
    var saveWrap = document.querySelector('[data-viva-price-save-wrap]');

    if (nowEl) nowEl.textContent = formatMoney(variant.price, data);

    if (oldEl && saveEl && saveWrap) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        oldEl.hidden = false;
        saveWrap.hidden = false;
        oldEl.textContent = formatMoney(variant.compare_at_price, data);
        var diff = variant.compare_at_price - variant.price;
        saveEl.textContent = '-' + formatMoney(diff, data);
      } else {
        oldEl.hidden = true;
        saveWrap.hidden = true;
        oldEl.textContent = '';
        saveEl.textContent = '';
      }
    }

    if (variant.featured_media_id != null && variant.featured_media_id !== '' && data.media) {
      var fmId = variant.featured_media_id;
      var m = data.media.find(function (x) {
        return String(x.id) === String(fmId);
      });
      if (m && (m.src || m.preview)) {
        applyMainMedia(m, String(fmId));
      }
      setActiveGalleryThumb(fmId);
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', String(variant.id));
    if (history.replaceState) {
      history.replaceState({}, '', url.toString());
    }

    var addBtn = form.querySelector('[name="add"]');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      syncAtcLabel(addBtn, variant.available ? '' : 'Épuisé');
    }

    syncOptionLabels(form);
    syncOptionAvailability(form, data);
    syncOptionPrices(form, data);
    syncStickyAtcFromHero(form);

    var imgEl = document.querySelector('.viva-pdp-sticky-atc__img[src]');
    if (imgEl && variant.featured_media_id != null && variant.featured_media_id !== '' && data.media) {
      var mm = data.media.find(function (x) {
        return String(x.id) === String(variant.featured_media_id);
      });
      if (mm && mm.preview) {
        imgEl.src = mm.preview;
      }
    }
  }

  function syncVariantForGalleryMedia(form, data, mediaId) {
    if (!form || !data || !data.variants || mediaId == null || mediaId === '') return;
    var current = currentOptionSelections(form, data);
    var vPick = pickVariantForMedia(data, mediaId, current);
    if (!vPick) return;
    optionSyncLock = true;
    setFormOptionsFromVariant(form, vPick, data);
    optionSyncLock = false;
    applyVariant(form, vPick, data);
  }

  function onGalleryThumbClick(e, form, data) {
    var a = e.target.closest('.gal-thumb');
    if (!a) return;
    e.preventDefault();
    var mid = a.getAttribute('data-media-id');
    if (!data || !data.media || mid == null || mid === '') return;
    var m = data.media.find(function (x) {
      return String(x.id) === String(mid);
    });
    if (m && (m.src || m.preview)) {
      applyMainMedia(m, String(mid));
    }
    setActiveGalleryThumb(mid);
    syncVariantForGalleryMedia(form, data, mid);
  }

  function currentGalleryMediaId() {
    var mainImg = document.querySelector('#viva-gal-main-img');
    if (mainImg && mainImg.getAttribute('data-media-id')) {
      return mainImg.getAttribute('data-media-id');
    }
    var active = document.querySelector('.gal-thumb.active');
    return active ? active.getAttribute('data-media-id') : null;
  }

  function moveGallery(step, form, data) {
    if (!data || !data.media || data.media.length < 2) return;
    var currentId = currentGalleryMediaId();
    var index = data.media.findIndex(function (m) {
      return String(m.id) === String(currentId);
    });
    if (index < 0) index = 0;
    var nextIndex = (index + step + data.media.length) % data.media.length;
    var next = data.media[nextIndex];
    if (!next) return;
    applyMainMedia(next, String(next.id));
    setActiveGalleryThumb(next.id);
    syncVariantForGalleryMedia(form, data, next.id);
  }

  function getProductRoot() {
    return (
      document.getElementById('viva-product-section') ||
      document.getElementById('viva-product-universal') ||
      document.querySelector('[data-viva-product]')
    );
  }

  function getGalleryRoot() {
    var root = getProductRoot();
    if (!root) return null;
    return (
      root.querySelector('.gallery') ||
      root.querySelector('.viva-universal-hero__gallery') ||
      root
    );
  }

  function initGalleryNavigation(form, data) {
    if (!data || !data.media || data.media.length < 2) return;
    var gallery = getGalleryRoot();
    if (!gallery || gallery.getAttribute('data-viva-gallery-bound') === 'true') return;
    gallery.setAttribute('data-viva-gallery-bound', 'true');

    qsa('[data-viva-gallery-prev]', gallery).forEach(function (btn) {
      btn.addEventListener('click', function () {
        moveGallery(-1, form, data);
      });
    });
    qsa('[data-viva-gallery-next]', gallery).forEach(function (btn) {
      btn.addEventListener('click', function () {
        moveGallery(1, form, data);
      });
    });

    var main =
      gallery.querySelector('.gal-main') ||
      gallery.querySelector('.viva-uh-gal-main') ||
      gallery.querySelector('.viva-pdp-media-frame');
    if (!main) return;

    var touchStartX = null;
    var touchStartY = null;
    main.addEventListener(
      'touchstart',
      function (ev) {
        if (!ev.touches || !ev.touches.length) return;
        touchStartX = ev.touches[0].clientX;
        touchStartY = ev.touches[0].clientY;
      },
      { passive: true }
    );
    main.addEventListener(
      'touchend',
      function (ev) {
        if (touchStartX == null || touchStartY == null || !ev.changedTouches || !ev.changedTouches.length) return;
        var dx = ev.changedTouches[0].clientX - touchStartX;
        var dy = ev.changedTouches[0].clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        moveGallery(dx < 0 ? 1 : -1, form, data);
      },
      { passive: true }
    );

    main.setAttribute('tabindex', main.getAttribute('tabindex') || '0');
    main.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowLeft') {
        ev.preventDefault();
        moveGallery(-1, form, data);
      } else if (ev.key === 'ArrowRight') {
        ev.preventDefault();
        moveGallery(1, form, data);
      }
    });
  }

  function ajaxCartAddUrl() {
    var u = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    if (u.indexOf('.js') === -1) {
      u = u.replace(/\/?$/, '') + '.js';
    }
    return u;
  }

  function refreshCartUiAndAnalytics(form, lineItem, options) {
    var T = window.VivaShopifyTracking;
    if (T && typeof T.handleAddToCartSuccess === 'function') {
      return T.handleAddToCartSuccess(form, lineItem, options);
    }
    document.dispatchEvent(new CustomEvent('add_to_cart', { detail: lineItem, bubbles: true }));
    document.dispatchEvent(new CustomEvent('updateCart', { bubbles: true }));
    return Promise.resolve();
  }

  /**
   * Aligne le PDP Viva sur le thème : /cart/add.js + événements analytics Shopify.
   */
  function bindVivaAjaxCart(form, data) {
    if (!form || form.getAttribute('data-viva-ajax-atc') === '0') return;

    var atc =
      typeof Shopify !== 'undefined' && Shopify.theme_settings && Shopify.theme_settings.atc_action
        ? Shopify.theme_settings.atc_action
        : 'always';

    if (atc === 'cart') return;

    form.addEventListener('submit', function (ev) {
      var addBtn = form.querySelector('button[name="add"], input[type="submit"][name="add"]');
      if (addBtn && addBtn.disabled) {
        ev.preventDefault();
        return;
      }

      ev.preventDefault();

      var idEl = form.querySelector('[name="id"]');
      var id = idEl ? idEl.value : '';
      if (!id) {
        form.submit();
        return;
      }

      var formData = new FormData(form);
      if (!formData.has('quantity')) formData.set('quantity', '1');

      if (addBtn) addBtn.disabled = true;

      fetch(ajaxCartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (r) {
          if (!r.ok || (r.data && r.data.status)) {
            var msg =
              (r.data &&
                (r.data.description || r.data.message || (r.data.errors && String(r.data.errors)))) ||
              'Impossible d’ajouter au panier.';
            throw new Error(msg);
          }
          if (atc === 'checkout') {
            refreshCartUiAndAnalytics(form, r.data, { redirect: 'checkout' });
            return;
          }
          try {
            if (document.querySelector('mini-cart')) {
              if (window.vivaFetchMinicartSectionHtml) {
                window._vivaMinicartSectionPending = window.vivaFetchMinicartSectionHtml();
              }
              var mcOpen =
                document.querySelector('#shopify-header-section mini-cart') ||
                document.querySelector('mini-cart#minicart') ||
                document.querySelector('mini-cart');
              if (mcOpen && typeof mcOpen.open === 'function') {
                document.body.classList.remove('scroll_up');
                document.body.classList.remove('scroll_down');
                mcOpen.open();
              }
            }
          } catch (eOpen) {}
          refreshCartUiAndAnalytics(form, r.data);
        })
        .catch(function (err) {
          console.warn('[Viva PDP] Ajout panier :', err);
          var T = window.VivaShopifyTracking;
          if (T && typeof T.emitCartError === 'function') {
            T.emitCartError(form, err && err.message ? err.message : String(err));
          }
          if (typeof window.alert === 'function') {
            try {
              window.alert(String(err.message || err));
            } catch (e2) {}
          }
        })
        .finally(function () {
          syncAtcButtonState(form, data);
        });
    });
  }

  function init() {
    var form = document.getElementById('viva-product-form');
    var data = parseJson('viva-product-json');

    if (form) {
      bindVivaAjaxCart(form, data);
    }

    /* Barre sticky : ne pas dépendre du JSON (variantes) — sinon la barre ne s’initialise jamais si le parse échoue. */
    if (form) {
      initStickyMobileAtc(form);
    }

    if (!form || !data) return;

    var schedulePrefetch = function () {
      prefetchNearbyProductMedia(data);
    };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(schedulePrefetch, { timeout: 1800 });
    } else {
      setTimeout(schedulePrefetch, 120);
    }

    function handleOptionInput(ev) {
      if (!isOptionField(ev.target)) return;
      onOptionChange(form, data, ev.target);
    }

    form.addEventListener('change', handleOptionInput);
    form.addEventListener('input', handleOptionInput);

    form.addEventListener(
      'click',
      function (ev) {
        var lab = ev.target.closest('label.size-opt, label.variant-opt, label.viva-size-opt');
        if (!lab || !form.contains(lab)) return;
        var inp = lab.querySelector('input[type="radio"]');
        if (!inp || inp.disabled) return;
        window.setTimeout(function () {
          if (inp.checked) onOptionChange(form, data, inp);
        }, 0);
      },
      true
    );

    syncOptionLabels(form);

    var initialOpts = currentOptionSelections(form, data);
    var initialVariant = findVariant(data, initialOpts);
    if (!initialVariant && data.variants && data.variants.length) {
      initialVariant =
        data.variants.find(function (v) {
          return v.available;
        }) || data.variants[0];
      if (initialVariant) {
        optionSyncLock = true;
        setFormOptionsFromVariant(form, initialVariant, data);
        optionSyncLock = false;
      }
    }
    if (initialVariant) {
      applyVariant(form, initialVariant, data);
      if (window.VivaShopifyTracking && typeof VivaShopifyTracking.emitProductSelect === 'function') {
        VivaShopifyTracking.emitProductSelect(form, data, initialVariant);
      }
    } else {
      syncOptionAvailability(form, data);
      syncAtcButtonState(form, data);
      syncOptionPrices(form, data);
    }

    var productRoot = getProductRoot();
    var gal = productRoot ? productRoot.querySelector('.gal-thumbs') : document.querySelector('.gal-thumbs');
    if (gal) {
      gal.addEventListener('click', function (ev) {
        onGalleryThumbClick(ev, form, data);
      });
    }
    initGalleryNavigation(form, data);
  }

  function initStickyMobileAtc(form) {
    var bar = document.getElementById('viva-pdp-sticky-atc');
    var mainBtn = form.querySelector('button[name="add"], input[type="submit"][name="add"]');
    if (!bar || !mainBtn) return;

    var STICKY_MOBILE_MQ = window.matchMedia('(max-width: 779px)');

    function isStickyMobileViewport() {
      return STICKY_MOBILE_MQ.matches;
    }

    function syncStickyMinicartState() {
      var openDetails = document.querySelector('details.minicart[open]');
      document.body.classList.toggle('viva-pdp-minicart-open', !!openDetails);
    }

    document.querySelectorAll('details.minicart').forEach(function (details) {
      if (details.dataset.vivaStickyMinicartBound === '1') return;
      details.dataset.vivaStickyMinicartBound = '1';
      details.addEventListener('toggle', syncStickyMinicartState);
    });
    syncStickyMinicartState();

    var stickyBtn = bar.querySelector('[data-viva-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!mainBtn.disabled) mainBtn.click();
      });
    }

    var io;
    function setStickyVisibility(show) {
      if (!isStickyMobileViewport()) show = false;
      if (show) {
        bar.classList.add('is-visible');
        bar.removeAttribute('hidden');
        bar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('viva-pdp-sticky-atc-open');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('hidden', '');
        bar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('viva-pdp-sticky-atc-open');
      }
    }

    function mainAtcInViewport() {
      var r = mainBtn.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      return r.top < vh - 4 && r.bottom > 4;
    }

    function onIntersect(entries) {
      var e = entries[0];
      if (!e) return;
      setStickyVisibility(!e.isIntersecting);
    }

    function connectIO() {
      if (io) {
        io.disconnect();
        io = null;
      }
      if (!isStickyMobileViewport()) return;
      if (typeof IntersectionObserver === 'undefined') {
        setStickyVisibility(!mainAtcInViewport());
        return;
      }
      io = new IntersectionObserver(onIntersect, {
        root: null,
        rootMargin: '0px 0px -2px 0px',
        threshold: [0, 0.05, 0.25]
      });
      io.observe(mainBtn);
    }

    function refreshStickyForViewport() {
      if (!isStickyMobileViewport()) {
        setStickyVisibility(false);
        if (io) {
          io.disconnect();
          io = null;
        }
        return;
      }
      connectIO();
      setStickyVisibility(!mainAtcInViewport());
    }

    refreshStickyForViewport();
    syncStickyAtcFromHero(form);

    if (typeof STICKY_MOBILE_MQ.addEventListener === 'function') {
      STICKY_MOBILE_MQ.addEventListener('change', refreshStickyForViewport);
    } else if (typeof STICKY_MOBILE_MQ.addListener === 'function') {
      STICKY_MOBILE_MQ.addListener(refreshStickyForViewport);
    }

    window.addEventListener('resize', refreshStickyForViewport, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
